import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "selectTaskType",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "offcanvasLabel",
  "aria-hidden": "true",
  "data-bs-scroll": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mt-3" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "offcanvasLabel"
}, "Select Task Type", -1)
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeSelectTaskTypeModal"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#taskSidebar",
  ref: "openTaskSidebar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_task_section = _resolveComponent("create-task-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_create_task_section, {
            onSelectTaskType: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createTask($event)))
          })
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("button", _hoisted_8, "Open", 512), [
      [_vShow, false]
    ])
  ]))
}